module.exports = "/_next/static/images/KotlinConfKUGKolkata1-7610488a0d1cecd17568d38ceb046003.jpg";